
import CatalogSearchSection from "../../../common/catalog/CatalogSearchSection";

export default function SearchSection({ initQuery, onSearch }) {
	return (
		<CatalogSearchSection
			title="جستجو در مقالات"
			placeholder="نام مقاله"
			initQuery={initQuery}
			onSearch={onSearch}
		/>
	);
}
